module.exports = __webpack_public_path__ + "img/hand.8e7c859a.png";